export default __webpack_public_path__ + "static/media/min3.175592aa.jpg";